import { render, staticRenderFns } from "./OrderResume.vue?vue&type=template&id=2bf185db&scoped=true"
import script from "./OrderResume.vue?vue&type=script&lang=js"
export * from "./OrderResume.vue?vue&type=script&lang=js"
import style0 from "./OrderResume.vue?vue&type=style&index=0&id=2bf185db&prod&lang=scss&scoped=true"
import style1 from "./OrderResume.vue?vue&type=style&index=1&id=2bf185db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf185db",
  null
  
)

export default component.exports